import { getVisibleBranches, getFilteredEntries, getFilteredExpenses } from './dataHelpers'
import { calcRevenue, calcMeasuredExcessProfit, calcTankSales, calcPumpSales } from '@petrotrack/shared'

// Per-date time series over the filtered product-day entries (+ station expenses).
export function getTimeSeriesData(currentUser, branches, entries, expenses, filters) {
  const ids = new Set(getVisibleBranches(currentUser, branches, filters).map((b) => b.id))
  const e = getFilteredEntries(entries, ids, filters)
  const x = filters.fuelTypeFilter === 'all' ? getFilteredExpenses(expenses, ids, filters) : []

  const byDate = {}
  const row = (d) => (byDate[d] ??= { date: d, revenue: 0, excessProfit: 0, expenses: 0, tankSales: 0, pumpSales: 0, netProfit: 0, amountToRemit: 0 })
  for (const entry of e) {
    const d = row(entry.date)
    d.revenue += calcRevenue(entry)
    d.excessProfit += calcMeasuredExcessProfit(entry)
    d.tankSales += calcTankSales(entry)
    d.pumpSales += calcPumpSales(entry)
  }
  for (const ex of x) row(ex.date).expenses += ex.amount
  for (const d of Object.values(byDate)) {
    d.netProfit = d.revenue - d.expenses
    d.amountToRemit = d.revenue + d.excessProfit - d.expenses
  }
  return Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date))
}

// Revenue / litres by product across the filtered range (ignores the product filter).
export function getFuelTypeBreakdown(currentUser, branches, entries, filters) {
  const ids = new Set(getVisibleBranches(currentUser, branches, { ...filters, fuelTypeFilter: 'all' }).map((b) => b.id))
  const e = getFilteredEntries(entries, ids, { ...filters, fuelTypeFilter: 'all' })
  const byProduct = {}
  for (const entry of e) {
    const p = (byProduct[entry.product] ??= { product: entry.product, revenue: 0, tankSales: 0 })
    p.revenue += calcRevenue(entry)
    p.tankSales += calcPumpSales(entry)
  }
  return Object.values(byProduct)
}
